import Base from '../Base/index'
import islandConst from '../const'
/*
* 练习模式
*/
// 不考虑分支情况，所以默认取第一个分支作为主分支

// createJs对象
const cjs = window.createjs

export default class Practice extends Base {
  constructor (props) {
    super({
      ...props,
      lastChessShow: props === 0, // 不显示
      chessClick: (sprite) => { // 棋子点击事件
        this.chessEvent(sprite)
      },
      complete: () => {
        // 初始化
        this.initPractice()
        this.stage.update()
      },
    })
    // 选中的棋子
    this.Selected = {}
  }

  initPractice () {
    const {type} = this.options
    // 如果是执行题，初始化棋盘初始数据
    if (type === 0) {
      // 步数
      this.nowChessStep = 0
      // 棋子
      this.nowchildren = this.sgfParse.children
      this.initSgfContent()
    }

    //其他类型，类型为4，初始化棋盘
    if (type === 4) {
      this.initSgfContent()
    }
  }

  chessEvent (sprite) {
    const {type} = this.options
    const {data} = this.sgfParse
    if (type === 3 || (type === 4 && sprite.chessType === islandConst.EMPTY)) {
      // 特殊题型
      sprite.selected = !sprite.selected
      if (data.AP[0] === 'M1.0') {
        this.Selected[sprite.coordinate.coordinate] = sprite.selected
      } else {
        this.Selected[sprite.point.letter] = sprite.selected
      }
      if (sprite.chessType === islandConst.BLACK) {
        if (sprite.selected) {
          sprite.gotoAndStop('c7')
        } else {
          sprite.gotoAndStop('c6')
        }
      } else if (sprite.chessType === islandConst.WHITE) {
        if (sprite.selected) {
          sprite.gotoAndStop('c2')
        } else {
          sprite.gotoAndStop('c1')
        }
      } else if (sprite.chessType === islandConst.EMPTY) {
        if (sprite.selected) {
          sprite.alpha = 1
          sprite.gotoAndStop('c15')
        } else {
          sprite.alpha = 0.01
          sprite.gotoAndStop('c15')
        }
      }
    } else if (type === 0 && sprite.alpha !== 1) {
      let status = false // 标记是否选择
      this.nowchildren.forEach(({data, children}) => {
        if (status) {
          return false
        }
        for (const item in data) {
          if (item === 'B' || item === 'W') {
            this.nowChessColor = item
            if (data[item][0].toLocaleUpperCase() === sprite.point.letter.toLocaleUpperCase()) {
              this.downNormalChess(data[item][0], item)
              status = true
              if (children.length === 0) {
                // 清除棋子绑定时间
                this.offChessBindEvents()
                this.options.onSuccess({
                  code: 200,
                  message: '恭喜',
                })
              } else {
                this.nowchildren = children
                this.chessAutoNext()
              }
            }
          }
        }
      })
      if (!status) {
        this.options.onError({
          code: 1,
          message: '落子错误',
        })
      }
    }

    this.stage.update()
  }

  // 自动下一步
  chessAutoNext () {
    const {data, children} = this.nowchildren[0]
    for (const item in data) {
      if (item === 'B' || item === 'W') {
        this.nowChessColor = item
        this.downNormalChess(data[item][0], item)
        if (children.length === 0) {
          this.options.onSuccess({
            code: 200,
            message: '恭喜',
          })
        } else {
          this.nowchildren = children
        }
      }
    }
  }

  downNormalChess (v, type) {
    this.nowChessStep++
    const num = this.letterTurnAllNum(v)
    const sprite = this.chess[num[0]][num[1]]
    sprite.chessStep = this.nowChessStep // 标识当前棋子在第几步
    if (type === 'B') {
      this.drawBackChess(sprite, sprite.x, sprite.y)
    } else if (type === 'W') {
      this.drawWhiteChess(sprite, sprite.x, sprite.y)
    }
    // 提子
    this.tiZiMethod(num, type)
  }

  offChessBindEvents () {
    this.chess.forEach(v => {
      v.forEach(item => {
        item.removeAllEventListeners()
      })
    })
  }

  getSelected () {
    const s = []
    Object.keys(this.Selected)
      .forEach((letter) => {
        if (this.Selected[letter]) {
          s.push(letter)
        }
      })
    return s
  }
}
